import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stRedPacketWithdrawals } from '../../../services/socialTradingService';

const RESOURCE = Resources.socialTradingRedpacketWithdrawals;

export const redpacketWithdrawalsDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 20 } = params.pagination || {};
    const status = String(params.filter?.status || '').trim() || undefined;
    const userId = String(params.filter?.userId || '').trim() || undefined;
    const targetAccount = String(params.filter?.targetAccount || '').trim() || undefined;
    const res = await stRedPacketWithdrawals({
      status,
      userId,
      targetAccount,
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.id })),
      total: res?.total ?? items.length,
    };
  },
};
